<!-- <p>reporting-parent works!</p> -->
 <div #scrollableDiv>
      <app-reporting-admin-menu (onLeftPanelClicked)="onLeftPanelClickedFun($event)" (ReportMainData)="ReportFun($event)">
      </app-reporting-admin-menu>
      <div *ngIf="tabVal==''" class="appLayout marginParentOnLeftPanelClose"
        [ngClass]="{'marginParentOnLeftPanelOpen' : isLeftPanelOpened == true}">
        <app-report-home></app-report-home>
      </div>
      <div class="reportName" *ngIf="tabVal!=''" [ngClass]="{'marginParentOnLeftPanelOpen' : isLeftPanelOpened == true}">
        {{ReportMainData.reportName}}</div>
      <div class="tabContainer" *ngIf="tabVal!=''" [ngClass]="{'marginParentOnLeftPanelOpen' : isLeftPanelOpened == true}">
        <div class="tabMainDiv">
          <div class="tabval1" (click)="tabClick('NewReport')" [ngClass]="{'tabval2': tabVal=='NewReport'}">New Report </div>
          <div class="tabval1" (click)="tabClick('SavedReport')" [ngClass]="{'tabval2': tabVal=='SavedReport'}">Saved Report
          </div>
          <div class="tabval1" (click)="tabClick('QueuedReport')" [ngClass]="{'tabval2': tabVal=='QueuedReport'}">Queued
            Report
          </div>
        </div>
      </div>
      <div *ngIf="tabVal=='SavedReport'" class="appLayout marginParentOnLeftPanelClose"
        [ngClass]="{'marginParentOnLeftPanelOpen' : isLeftPanelOpened == true}">
        <app-saved-filters [ReportMainData]="ReportMainData">
        </app-saved-filters>
      </div>
      <div *ngIf="tabVal=='QueuedReport'" class="appLayout marginParentOnLeftPanelClose"
        [ngClass]="{'marginParentOnLeftPanelOpen' : isLeftPanelOpened == true}">
        <app-queued-report [ReportMainData]="ReportMainData">
        </app-queued-report>
      </div>
      <div *ngIf="tabVal=='NewReport'">
        <div *ngIf="loadBookedTimeByResourceReport" class="appLayout marginParentOnLeftPanelClose"
          [ngClass]="{'marginParentOnLeftPanelOpen' : isLeftPanelOpened == true}">
          <app-booked-time-by-resource-report [ReportMainData]="ReportMainData">
          </app-booked-time-by-resource-report>
        </div>
        <div *ngIf="loadBookedTimeByEngagementReport" class="appLayout marginParentOnLeftPanelClose"
          [ngClass]="{'marginParentOnLeftPanelOpen' : isLeftPanelOpened == true}">
          <app-booked-time-by-engagement-report   [ReportMainData]="ReportMainData">
          </app-booked-time-by-engagement-report>
        </div>
        <div *ngIf="loadAvailabilityByForecastedHoursReport" class="appLayout marginParentOnLeftPanelClose"
          [ngClass]="{'marginParentOnLeftPanelOpen' : isLeftPanelOpened == true}">
          <app-availability-by-forecasted-hours-report  
            [ReportMainData]="ReportMainData"></app-availability-by-forecasted-hours-report>
        </div>
        <div *ngIf="loadAuditTrailReport" class="appLayout marginParentOnLeftPanelClose"
          [ngClass]="{'marginParentOnLeftPanelOpen' : isLeftPanelOpened == true}">
          <app-audit-trail-report   [ReportMainData]="ReportMainData"></app-audit-trail-report>
        </div>
        <div *ngIf="loadAdoptionReport" class="appLayout marginParentOnLeftPanelClose"
          [ngClass]="{'marginParentOnLeftPanelOpen' : isLeftPanelOpened == true}">
          <app-adoption-report   [ReportMainData]="ReportMainData"></app-adoption-report>
        </div>
      </div>

</div>